import React, { FunctionComponent } from 'react';
import { Avatar, Card, CardContent, Stack, Typography } from '@mui/material';

import { getShortName } from '../../../../../../../../helper';
import { IUser } from '../../../../../../../../store/UserSlice';

interface LessonHistoryUserCardProps {
  lessonHistoryUser: IUser;
}

const LessonHistoryUserCard: FunctionComponent<LessonHistoryUserCardProps> = ({
  lessonHistoryUser,
}) => {
  const fullName = getShortName(
    lessonHistoryUser.firstname,
    lessonHistoryUser.lastname
  );

  return (
    <Card elevation={0}>
      <CardContent style={{ padding: 0 }}>
        <Stack direction="row" columnGap="8px" alignItems="center">
          <Avatar
            src={lessonHistoryUser.avatar}
            sx={{ width: '40px', height: '40px' }}
          />
          <Stack>
            <Typography fontWeight={500} fontSize="14px" color="#1E293B">
              {fullName}
            </Typography>
            {lessonHistoryUser.country ? (
              <Typography fontWeight={400} fontSize="12px" color="#94A3B8">
                {lessonHistoryUser.country}
              </Typography>
            ) : null}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default LessonHistoryUserCard;
